import { Button, FormControl, Grid, TextField } from "@material-ui/core";
import { EditOutlined } from "@material-ui/icons";
import { getDatabase, ref, update } from "firebase/database";
import React from "react";
import { BeatLoader } from "react-spinners";

const AddWithdrawSetting = () => {
  const [type, setType] = React.useState("");
  const [amount, setAmount] = React.useState("");

  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");

  const saveNewWithdrawSetting = () => {
    if (type && amount) {
      setLoading(true);
      const currentDate = new Date();
      const withdrawId = currentDate.getTime();

      const w = {
        withdrawId,
        type,
        amount,
      };
      const db = getDatabase();

      update(ref(db, `WithdrawSetting/${withdrawId}`), w)
        .then((res) => {
          setLoading(false);
          setAmount("");
          setType("");
          setError("");
        })
        .catch((err) => {
          setLoading(false);
          setError("Job Add Failed.");
        });
    } else {
      setLoading(false);
      setError("Enter All Input Data");
    }
  };

  return (
    <div>
      <Grid container spacing={5}>
        <Grid item xs={10} sm={10} md={6}>
          <FormControl fullWidth>
            <TextField
              value={type}
              onChange={(e) => setType(e.target.value)}
              label="Withdraw Type"
              variant="outlined"
              color="secondary"
              required
              type="text"
            />
            <br />
            <br />

            <TextField
              value={amount}
              onChange={(e) => setAmount(parseFloat(e.target.value))}
              label="Amount"
              variant="outlined"
              color="secondary"
              required
              type="number"
            />
            <br />
            <br />
            <p style={{ color: "red" }}>{error}</p>
            <br />
            <br />
            {loading ? (
              <BeatLoader loading={loading} />
            ) : (
              <Button
                disabled={loading}
                onClick={() => saveNewWithdrawSetting()}
                style={{ marginBottom: "10px" }}
                color="secondary"
                variant="outlined"
                type="submit"
                endIcon={<EditOutlined />}
              >
                Save
              </Button>
            )}
          </FormControl>
        </Grid>
      </Grid>
    </div>
  );
};

export default AddWithdrawSetting;
